import * as S from "./styles.ts";

interface ISliderLabelProps {
  label?: number | string;
  left?: number;
  onClick: (e: any) => void;
  disabled?: boolean;
}

const SliderLabel = ({ label, left, onClick, disabled }: ISliderLabelProps) => {
  return (
    <S.SliderLabelWrapper
      $left={left}
      onClick={onClick}
      aria-label={`Button to move slider to ${label} users`}
      tabIndex={label === undefined ? -1 : 0}
      disabled={disabled}
    >
      {label}
    </S.SliderLabelWrapper>
  );
};

export default SliderLabel;
